import { useQuery } from '@tanstack/react-query';

import { getProductDrafts } from '../api/getProductDrafts';

export const useProductDrafts = () => {
  const query = useQuery({
    queryKey: ['products-drafts'],
    queryFn: async () => {
      const response = await getProductDrafts();

      return response.data;
    },
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    staleTime: 0
  });

  return query;
};
